import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import Grid from "components/common/Grid";
import Button from "components/common/Button";
import Modal from "components/common/Modal";
import Avatar from "components/common/Avatar";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import { makeStyles } from "@mui/styles";
import CircularProgress from "@mui/material/CircularProgress";
import CancelIcon from "@mui/icons-material/Cancel";

const ViewDetail = ({ props }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const classes = useStyles();

  return (
    <>
      <ButtonStyle
        onClick={handleOpen}
        size="small"
        color="success"
        variant="contained"
      >
        View Details
      </ButtonStyle>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.rootBox}>
          <CancelIcon
            onClick={handleClose}
            className={classes.cancleStyle}
          ></CancelIcon>
          <Grid container spacing={0}>
            <Grid item xs={12} sm={2} lg={1}>
              <Box className={classes.progressBox}>
                <CircularProgress
                  variant="determinate"
                  size="69px"
                  value={props ? props.progress : 1}
                />
                <Avatar
                  src="/images/car.png"
                  className={classes.carStyle}
                  variant="rounded"
                ></Avatar>
                <Text
                  variant="caption"
                  sx={{
                    width: "38px",
                    height: "14px",
                    position: "absolute",
                    left: "55px",
                    top: "60px",
                    font: "normal normal 600 12px/16px Nunito Sans",
                  }}
                  component="div"
                  color="text.secondary"
                >
                  {`${Math.round(props ? props.progress : "")}%`}
                </Text>
              </Box>
            </Grid>
            <Grid item xs={12} sm={7} lg={8}>
              <Box>
                <Text
                  variant="h"
                  component="div"
                  gutterBottom
                  sx={{
                    color: "#474747",
                    marginTop: "9px",
                  }}
                >
                  {props !== undefined ? props.StationName : ""}
                </Text>
                <Text
                  variant="h"
                  component="div"
                  gutterBottom
                  sx={{
                    color: "#707070",
                    fontSize: "14px",
                  }}
                >
                  {props !== undefined ? props.networkName : ""}
                  {}
                </Text>
              </Box>
            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <Box
                sx={{
                  display: "flex",
                  border: "1px solid #EBEBEB",
                  flexDirection: "column",
                  marginBottom: "1rem",
                  textAlign: "center",
                  marginRight: "20px",
                }}
              >
                <Box
                  sx={{
                    background:
                      "rgb(25, 170, 105, 0.1) 0% 0% no-repeat padding-box",
                    borderRadius: "4px",
                    width: "107px",
                    marginLeft: "45px",
                    marginTop: "5px",
                  }}
                >
                  <Text
                    variant="h"
                    component="div"
                    gutterBottom
                    sx={{
                      letterSpacing: "0.28px",
                      color: "#19AA69",
                      opacity: "1",
                      textAlign: "center",

                      marginTop: "5px",
                    }}
                  >
                    Booked Slot
                  </Text>
                </Box>

                <Text
                  variant="span"
                  component="div"
                  gutterBottom
                  sx={{
                    letterSpacing: "0px",
                    color: "#474747",
                    fontSize: "14px",
                    margin: "5px 0px",
                  }}
                >
                  {props !== undefined ? props.date : ""}
                  <br></br>
                  {props !== undefined ? props.time : ""}
                </Text>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} lg={4}>
              <Box sx={{ border: "1px solid #EBEBEB", height: "100%" }}>
                <Text variant="h" component="div" gutterBottom sx={headings}>
                  Charging Details
                </Text>

                <Text variant="h" component="div" sx={listStyle}>
                  <Avatar
                    src={props.img}
                    alt="logo"
                    sx={{
                      width: "24px",
                      height: "24px",
                      marginRight: "10px",
                      marginTop: "-4px",
                    }}
                  />
                  {props !== null ? props?.carName : " "}
                </Text>
                <Text variant="h" component="div" sx={listStyle}>
                  <Avatar
                    src={props.chademoImage}
                    alt="logo"
                    sx={{
                      width: "24px",
                      height: "24px",
                      marginRight: "10px",
                      marginTop: "-4px",
                    }}
                  />
                  {props !== undefined ? props.chademo : ""}
                </Text>

                <Text variant="h" component="div" sx={listStyle}>
                  <Avatar
                    src="/images/power.png"
                    alt="logo"
                    sx={{
                      width: "24px",
                      height: "24px",
                      marginRight: "10px",
                      marginTop: "-4px",
                    }}
                  />
                  {props !== undefined ? props.power : ""}
                </Text>
                <Text variant="h" component="div" sx={listStyle}>
                  <Avatar
                    src="/images/time.png"
                    alt="logo"
                    sx={{
                      width: "24px",
                      height: "24px",
                      marginRight: "10px",
                      marginTop: "-4px",
                    }}
                  />
                  {props !== undefined ? props.SecondTime : ""}
                </Text>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
              <Box
                sx={{
                  border: "1px solid #EBEBEB",
                  height: 195,
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <Text variant="h" component="div" gutterBottom sx={headings}>
                  Amenities Used
                </Text>
                <Box sx={{ overflow: "scroll", height: "90%" }}>
                  {props
                    ? props.amenities?.map((amenity, index) => (
                        <Text
                          variant="h"
                          component="div"
                          sx={listStyle}
                          key={index}
                        >
                          <Avatar
                            src={amenity.thumbnail}
                            alt="logo"
                            sx={{
                              width: "24px",
                              height: "24px",
                              marginRight: "10px",
                              marginTop: "-4px",
                            }}
                          />
                          {amenity.name}
                        </Text>
                      ))
                    : ""}
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} lg={4}>
              <Box sx={{ border: "1px solid #EBEBEB", height: "100%" }}>
                <Text variant="h" component="div" gutterBottom sx={headings}>
                  Payment Details
                </Text>

                <Text
                  variant="h"
                  component="div"
                  sx={{
                    color: "#707070",
                    marginTop: "20px",
                    marginLeft: "20px",
                    fontSize: "14px",
                  }}
                ></Text>
                <Box sx={{ borderBottom: "1px solid #EBEBEB" }}>
                  <Grid container>
                    <Grid item xs={8}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          color: "#707070",
                          marginTop: "20px",
                          marginLeft: "20px",
                          fontSize: "14px",
                        }}
                      >
                        Advance Paid
                      </Text>
                    </Grid>
                    <Grid item xs={4}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          font: " normal normal normal 14px/19px Nunito Sans",
                          color: "#707070",
                          marginTop: "20px",
                          marginRight: "20px",
                          textAlign: "right",
                        }}
                      >
                        {props?.gst[0]?.advance_amt}
                      </Text>
                    </Grid>
                    <Grid item xs={8}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          font: " normal normal normal 14px/19px Nunito Sans",
                          color: "#707070",
                          marginTop: "5px",
                          marginLeft: "20px",
                        }}
                      >
                        Balance paid
                      </Text>
                    </Grid>
                    <Grid item xs={4}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          font: " normal normal normal 14px/19px Nunito Sans",
                          color: "#707070",
                          marginTop: "5px",
                          marginRight: "20px",
                          textAlign: "right",
                        }}
                      >
                        {props?.gst[0]?.gross_amt}
                      </Text>
                    </Grid>
                    <Grid item xs={8}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          font: " normal normal normal 14px/19px Nunito Sans",
                          color: "#707070",
                          marginTop: "5px",
                          marginLeft: "20px",
                        }}
                      >
                        Convenience Fee
                      </Text>
                    </Grid>
                    <Grid item xs={4}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          font: " normal normal normal 14px/19px Nunito Sans",
                          color: "#707070",
                          marginTop: "5px",
                          marginRight: "20px",
                          textAlign: "right",
                        }}
                      >
                        {props?.gst[0]?.convenience_amount}
                      </Text>
                    </Grid>

                    <Grid item xs={8}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          font: " normal normal normal 14px/19px Nunito Sans",
                          color: "#707070",
                          marginTop: "5px",
                          marginLeft: "20px",
                        }}
                      >
                        gst
                      </Text>
                    </Grid>
                    <Grid item xs={4}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          font: " normal normal normal 14px/19px Nunito Sans",
                          color: "#707070",
                          marginTop: "5px",
                          marginRight: "20px",
                          textAlign: "right",
                        }}
                      >
                        {props?.gst[0]?.tax_amount}
                      </Text>
                    </Grid>
                  </Grid>
                </Box>
                <Box>
                  <Grid container>
                    <Grid item xs={6}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          font: " normal normal 600 16px/24px Nunito Sans;",
                          color: "#474747",
                          marginTop: "14px",
                          marginLeft: "20px",
                        }}
                      >
                        Total Amount
                      </Text>
                    </Grid>
                    <Grid item xs={6}>
                      <Text
                        variant="h"
                        component="div"
                        sx={{
                          font: " normal normal 600 16px/24px Nunito Sans;",
                          color: "#474747",
                          marginTop: "14px",
                          textAlign: "right",
                          marginRight: "20px",
                        }}
                      >
                        {props?.gst[0]?.total_amount}
                      </Text>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};
const ButtonStyle = styled(Button)({
  backgroundColor: "#19AA69",
  textTransform: "capitalize",
  padding: "10px",
  margin: "0px 10px 10px 10px",
});

const listStyle = {
  color: "#707070",
  marginTop: "20px",
  marginLeft: "20px",
  display: "flex",
  fontSize: "14px",
};
const headings = {
  color: "#474747",
  backgroundColor: "#F9F9F9",
  padding: "5px",
  borderBottom: "1px solid #EBEBEB",
};

const useStyles = makeStyles((theme) => ({
  rootBox: {
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    width: "75vw",
    height: "auto",
    position: "absolute",
    top: "50%",
    left: "50%",
    padding: "30px",
    "@media (max-width:768px)": {
      overflowY: "scroll",
      height: "80vh",
    },
  },
  cancleStyle: {
    position: "absolute",
    top: "5px",
    right: "10px",
    cursor: "pointer",
  },
  carStyle: {
    width: "38px",
    height: "14px",
    position: "absolute",
    left: "48px",
    top: "40px",
  },
  progressBox: { marginLeft: "10px" },
}));

export default ViewDetail;
